module.exports = __webpack_public_path__ + "static/img/wheel-pan.139689e9.png";